import type { FC } from "react";
import { Box } from "@material-ui/core";
import bkvLogo from "src/assets/bkv-logo.svg";
import "src/lib/cake-loader.min.css";

const SplashScreen = ({ loading }) => (
  <Box
    sx={{
      height: "100%",
      width: "100%",
      position: "relative",
      zIndex: -100,
    }}
  >
    <Box
      sx={{
        opacity: loading ? 1 : 0,
        transition: "opacity 0.3s ease-in-out",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <div className="loader-frame loader-js">
        <div className="loader">
          <svg
            id="Layer_2"
            data-name="Layer 2"
            xmlns="http://www.w3.org/2000/svg"
            width="87.5"
            height="97.6"
            viewBox="0 0 87.5 97.6"
          >
            <path
              className="pies pie__5"
              d="M25.4,66.7H0S0,83.5,0,83.5c0,3.4,1.2,6.5,3.2,8.9l23.2-23.2c.9-.9,.3-2.5-1-2.5Z"
            />
            <path
              className="pies pie__6"
              d="M7,42.1C2.6,47.7,0,54.8,0,62.4v1.7s25.5,0,25.5,0c1.3,0,1.9-1.6,1-2.5L7,42.1Z"
            />
            <path
              className="pies pie__7"
              d="M8.8,40l19.6,19.6c.9,.9,2.5,.3,2.5-1V28.1s-8.7,3-8.7,3c-5.2,1.8-9.8,4.9-13.4,8.8Z"
            />
            <path
              className="pies pie__8"
              d="M39.2,25.2l-5.6,2v31.4c0,1.3,1.6,1.9,2.5,1l20.2-20.2c.3-.3,19.9-20,29.4-39.5-4.1,4.3-16,14.1-46.4,25.2Z"
            />
            <path
              className="pies pie__3"
              d="M33.6,72.1v25.4s1.6,0,1.6,0c7.5,0,14.6-2.6,20.3-7l-19.5-19.5c-.9-.9-2.5-.3-2.5,1Z"
            />
            <path
              className="pies pie__4"
              d="M28.4,71.1L5.1,94.3c2.4,2,5.5,3.2,8.9,3.2H30.8s0-25.4,0-25.4c0-1.3-1.6-1.9-2.5-1Z"
            />
            <path
              className="pies pie__1"
              d="M74.9,21.9c-8.4,11.1-16.7,19.4-16.8,19.4l-20.2,20.2c-.9,.9-.3,2.5,1,2.5h31.4s1.1-3.1,1.1-3.1c0,0,15.5-48.4,16.1-58.8-3,6-7.2,12.6-12.7,19.8Z"
            />
            <path
              className="pies pie__2"
              d="M38,69.2l19.6,19.6c3.9-3.6,7-8.1,8.8-13.4l3-8.7h-30.4c-1.3,0-1.9,1.6-1,2.5Z"
            />
          </svg>
        </div>
      </div>
      <style>{`
        html{
            width: 100%;
            height: 100%;
        }
      `}</style>
    </Box>
  </Box>
);

export default SplashScreen;
